module.exports = __webpack_public_path__ + "media/images/icons/close-589d156f77003e42d89f9bfebec7844d.svg";